/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import './credit_line';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "CreditLineTransaction": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantDescription": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transactionAmountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "availableBalanceMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.corporate_card.resources.CreditLineTransaction.Type",
                    "id": 6,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.corporate_card.resources.CreditLineTransaction.State",
                    "id": 9,
                    "rule": "optional"
                  },
                  "postedAt": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "billPayment": {
                    "type": ".squareup.corporate_card.resources.CreditLineTransaction.BillPaymentDetails",
                    "id": 11,
                    "rule": "optional"
                  },
                  "interestAccrual": {
                    "type": ".squareup.corporate_card.resources.CreditLineTransaction.InterestAccrualDetails",
                    "id": 12,
                    "rule": "optional"
                  },
                  "adjustment": {
                    "type": ".squareup.corporate_card.resources.CreditLineTransaction.AdjustmentDetails",
                    "id": 13,
                    "rule": "optional"
                  },
                  "declineReason": {
                    "type": ".squareup.corporate_card.resources.CreditLineTransaction.DeclineReason",
                    "id": 14,
                    "rule": "optional"
                  },
                  "merchantCategoryCode": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "attemptedTransactionAmountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 16,
                    "rule": "optional"
                  },
                  "purchaseDispute": {
                    "type": ".squareup.corporate_card.resources.CreditLineTransaction.PurchaseDisputeDetails",
                    "id": 17,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "CREDIT_LINE_TRANSACTION_TYPE_DO_NOT_USE": 0,
                      "CAPTURE": 1,
                      "REFUND": 2,
                      "BILL_PAYMENT": 3,
                      "CARD_TRANSACTION": 4,
                      "INTEREST_ACCRUAL": 5,
                      "BILL_PAYMENT_REVERSAL": 6,
                      "INTEREST_ACCRUAL_REVERSAL": 7,
                      "SERVICE_CREDIT": 8,
                      "SERVICE_CREDIT_REVERSAL": 9,
                      "ADJUSTMENT": 10,
                      "PURCHASE_DISPUTE": 11
                    }
                  },
                  "State": {
                    "values": {
                      "CREDIT_LINE_TRANSACTION_STATE_DO_NOT_USE": 0,
                      "PENDING": 1,
                      "COMPLETED": 2,
                      "REFUNDED": 3,
                      "FAILED": 4,
                      "DECLINED": 5
                    }
                  },
                  "BillPaymentDetails": {
                    "fields": {
                      "paymentMethod": {
                        "type": ".squareup.corporate_card.resources.CreditLineTransaction.BillPaymentDetails.PaymentMethod",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isSmartDebit": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "holdRate": {
                        "type": ".squareup.corporate_card.resources.CreditLineTransaction.BillPaymentDetails.HoldRateDetails",
                        "id": 2
                      },
                      "ach": {
                        "type": ".squareup.corporate_card.resources.CreditLineTransaction.BillPaymentDetails.AchDetails",
                        "id": 3
                      }
                    },
                    "nested": {
                      "PaymentMethod": {
                        "values": {
                          "PAYMENT_METHOD_DO_NOT_USE": 0,
                          "ACH": 1,
                          "HOLD_RATE": 2,
                          "CHECK": 3
                        }
                      },
                      "HoldRateDetails": {
                        "fields": {
                          "posSalesMoney": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "AchDetails": {
                        "fields": {
                          "accountToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "accountNumberSuffix": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "accountType": {
                            "type": ".squareup.corporate_card.resources.CreditLine.PaymentAccount.AccountType",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "payment_details": {
                        "oneof": ["holdRate", "ach"]
                      }
                    }
                  },
                  "AdjustmentDetails": {
                    "fields": {
                      "adjustmentType": {
                        "type": ".squareup.corporate_card.resources.CreditLineTransaction.AdjustmentDetails.AdjustmentType",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "AdjustmentType": {
                        "values": {
                          "ADJUSTMENT_TYPE_DO_NOT_USE": 0,
                          "DEBIT": 1,
                          "CREDIT": 2
                        }
                      }
                    }
                  },
                  "InterestAccrualDetails": {
                    "fields": {
                      "averageDailyPrincipalBalance": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "aprBps": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "periodStartAt": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "periodEndAt": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "PurchaseDisputeDetails": {
                    "fields": {
                      "status": {
                        "type": ".squareup.corporate_card.resources.CreditLineTransaction.PurchaseDisputeDetails.DisputeStatus",
                        "id": 1,
                        "rule": "optional"
                      },
                      "timestamps": {
                        "type": ".squareup.corporate_card.resources.CreditLineTransaction.PurchaseDisputeDetails.Timestamps",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "DisputeStatus": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "PENDING": 1,
                          "WON": 2,
                          "LOSS": 3
                        }
                      },
                      "Timestamps": {
                        "fields": {
                          "submittedAt": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "expiredAt": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "wonAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "lostAt": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "purchaseRepostedAt": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "DeclineReason": {
                    "fields": {
                      "issuerErrorCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "issuerErrorDescription": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "issuerErrorType": {
                        "type": ".squareup.corporate_card.resources.CreditLineTransaction.DeclineReason.IssuerErrorType",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "IssuerErrorType": {
                        "values": {
                          "ISSUER_ERROR_TYPE_DO_NOT_USE": 0,
                          "INSUFFICIENT_FUNDS": 1,
                          "EXPIRED_CARD": 2,
                          "ACCOUNT_CLOSED": 3,
                          "CARD_LOCKED": 4,
                          "INVALID_CVV": 5,
                          "CARD_NOT_ACTIVATED": 6,
                          "EXCEEDS_MAXIMUM_PURCHASE_AMOUNT": 7,
                          "OTHER": 8
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.Type && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.State && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.BillPaymentDetails && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.BillPaymentDetails?.nested?.PaymentMethod && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.BillPaymentDetails?.nested?.HoldRateDetails && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.BillPaymentDetails?.nested?.AchDetails && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.AdjustmentDetails && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.AdjustmentDetails?.nested?.AdjustmentType && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.InterestAccrualDetails && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.PurchaseDisputeDetails && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.PurchaseDisputeDetails?.nested?.DisputeStatus && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.PurchaseDisputeDetails?.nested?.Timestamps && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.DeclineReason && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLineTransaction?.nested?.DeclineReason?.nested?.IssuerErrorType) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A credit line transaction
 * --
 *
 * SOURCE CreditLineTransaction @ squareup/corporate_card/resources/credit_line_transaction.proto at 11:1
 */
export const CreditLineTransaction = $root.lookupType('squareup.corporate_card.resources.CreditLineTransaction');
fixType(CreditLineTransaction);
Builder.createAndAttachToType(CreditLineTransaction);
/**
 * --
 * The type of transaction
 * --
 *
 * SOURCE Type @ squareup/corporate_card/resources/credit_line_transaction.proto at 15:3
 */
CreditLineTransaction.Type = $root.lookupEnum('squareup.corporate_card.resources.CreditLineTransaction.Type').values;
/**
 * SOURCE State @ squareup/corporate_card/resources/credit_line_transaction.proto at 52:3
 */
CreditLineTransaction.State = $root.lookupEnum('squareup.corporate_card.resources.CreditLineTransaction.State').values;
/**
 * SOURCE BillPaymentDetails @ squareup/corporate_card/resources/credit_line_transaction.proto at 71:3
 */
CreditLineTransaction.BillPaymentDetails = $root.lookupType('squareup.corporate_card.resources.CreditLineTransaction.BillPaymentDetails');
fixType(CreditLineTransaction.BillPaymentDetails);
Builder.createAndAttachToType(CreditLineTransaction.BillPaymentDetails);
/**
 * SOURCE PaymentMethod @ squareup/corporate_card/resources/credit_line_transaction.proto at 72:5
 */
CreditLineTransaction.BillPaymentDetails.PaymentMethod = $root.lookupEnum('squareup.corporate_card.resources.CreditLineTransaction.BillPaymentDetails.PaymentMethod').values;
/**
 * SOURCE HoldRateDetails @ squareup/corporate_card/resources/credit_line_transaction.proto at 91:5
 */
CreditLineTransaction.BillPaymentDetails.HoldRateDetails = $root.lookupType('squareup.corporate_card.resources.CreditLineTransaction.BillPaymentDetails.HoldRateDetails');
fixType(CreditLineTransaction.BillPaymentDetails.HoldRateDetails);
Builder.createAndAttachToType(CreditLineTransaction.BillPaymentDetails.HoldRateDetails);
/**
 * SOURCE AchDetails @ squareup/corporate_card/resources/credit_line_transaction.proto at 96:5
 */
CreditLineTransaction.BillPaymentDetails.AchDetails = $root.lookupType('squareup.corporate_card.resources.CreditLineTransaction.BillPaymentDetails.AchDetails');
fixType(CreditLineTransaction.BillPaymentDetails.AchDetails);
Builder.createAndAttachToType(CreditLineTransaction.BillPaymentDetails.AchDetails);
/**
 * SOURCE AdjustmentDetails @ squareup/corporate_card/resources/credit_line_transaction.proto at 124:3
 */
CreditLineTransaction.AdjustmentDetails = $root.lookupType('squareup.corporate_card.resources.CreditLineTransaction.AdjustmentDetails');
fixType(CreditLineTransaction.AdjustmentDetails);
Builder.createAndAttachToType(CreditLineTransaction.AdjustmentDetails);
/**
 * SOURCE AdjustmentType @ squareup/corporate_card/resources/credit_line_transaction.proto at 125:5
 */
CreditLineTransaction.AdjustmentDetails.AdjustmentType = $root.lookupEnum('squareup.corporate_card.resources.CreditLineTransaction.AdjustmentDetails.AdjustmentType').values;
/**
 * SOURCE InterestAccrualDetails @ squareup/corporate_card/resources/credit_line_transaction.proto at 139:3
 */
CreditLineTransaction.InterestAccrualDetails = $root.lookupType('squareup.corporate_card.resources.CreditLineTransaction.InterestAccrualDetails');
fixType(CreditLineTransaction.InterestAccrualDetails);
Builder.createAndAttachToType(CreditLineTransaction.InterestAccrualDetails);
/**
 * SOURCE PurchaseDisputeDetails @ squareup/corporate_card/resources/credit_line_transaction.proto at 150:3
 */
CreditLineTransaction.PurchaseDisputeDetails = $root.lookupType('squareup.corporate_card.resources.CreditLineTransaction.PurchaseDisputeDetails');
fixType(CreditLineTransaction.PurchaseDisputeDetails);
Builder.createAndAttachToType(CreditLineTransaction.PurchaseDisputeDetails);
/**
 * SOURCE DisputeStatus @ squareup/corporate_card/resources/credit_line_transaction.proto at 151:5
 */
CreditLineTransaction.PurchaseDisputeDetails.DisputeStatus = $root.lookupEnum('squareup.corporate_card.resources.CreditLineTransaction.PurchaseDisputeDetails.DisputeStatus').values;
/**
 * SOURCE Timestamps @ squareup/corporate_card/resources/credit_line_transaction.proto at 159:5
 */
CreditLineTransaction.PurchaseDisputeDetails.Timestamps = $root.lookupType('squareup.corporate_card.resources.CreditLineTransaction.PurchaseDisputeDetails.Timestamps');
fixType(CreditLineTransaction.PurchaseDisputeDetails.Timestamps);
Builder.createAndAttachToType(CreditLineTransaction.PurchaseDisputeDetails.Timestamps);
/**
 * SOURCE DeclineReason @ squareup/corporate_card/resources/credit_line_transaction.proto at 178:3
 */
CreditLineTransaction.DeclineReason = $root.lookupType('squareup.corporate_card.resources.CreditLineTransaction.DeclineReason');
fixType(CreditLineTransaction.DeclineReason);
Builder.createAndAttachToType(CreditLineTransaction.DeclineReason);
/**
 * SOURCE IssuerErrorType @ squareup/corporate_card/resources/credit_line_transaction.proto at 179:5
 */
CreditLineTransaction.DeclineReason.IssuerErrorType = $root.lookupEnum('squareup.corporate_card.resources.CreditLineTransaction.DeclineReason.IssuerErrorType').values;